import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_PERIOD,
  FILTER_MASTER_CAMPAIGNS,
  FILTER_AGENCIES,
  FILTER_INFLUENCERS_CHANNELS,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
} from 'scenes/Influencers/InfluencersCampaigns/constants';

import * as Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_PERIOD,
  FILTER_MASTER_CAMPAIGNS,
  FILTER_AGENCIES,
  FILTER_INFLUENCERS_CHANNELS,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
];

const PrimaryFilters = () => (
  <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
    <Filters.Period />
    <Filters.MasterCampaigns />
    <Filters.Agencies />
    <Filters.InfuencersChannels />
    <Filters.Applications />
    <Filters.Networks />
    <Filters.Platforms />
    <Filters.Countries />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
